import posthog from './analytics/posthog';
import RouteTracker from './analytics/RouteTracker';
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Layout, Row, Skeleton } from "antd";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Modal, Result, Button } from "antd";
import { FieldTimeOutlined, SyncOutlined } from "@ant-design/icons";
import styled from "styled-components";
// Components
import SideBar from "molecules/SideMenu";
import Header from "molecules/Header";
import Container from "pages/Container";
import { routeToKeyMap, STATUS_CODE } from "common/Constants";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setIsUserLoggedIn,
  setSystemDate,
  setUsernName,
  setLoadingDataFirstTime,
  setBreakTypesList,
  setDepartmentList,
  setLeaveCategoryList,
  setLocationList,
  setPunchActions,
  setUserRole,
  setDepartmentId,
  setRoleList,
  setCheckedIn,
  setCheckInLocationId,
  setIsOnBreak,
  setUserList,
  setStatusList,
  setAllDepartmentList,
  setPunchId,
  setBreakId,
  toggleProcessingModal,
  setShiftTimeMaster,
  setUserProfile,
  clearStore,
  setProfilePic,
  setMenuList,
  setLevelList,
  setClientid,
  setCurrentPlan,
  setTrailPeriod,
  setUserMenuList,
  setCheckInDepartmentId,
  setBandList,
  setSupervisorList,
  setActiveMenuList,
  setLoadingRoute,
  setStatusCodes,
  setCRMManagingOfficeList,
  setUserLocalTimeZone,
  setUserAmPm,
  setLoadNewDataList,
  setHigherOfficialsList,
  setChargeoutRatesList,
  setCountryList
} from "redux/actions";
import {
  getIsUserLoggedIn,
  getUserName,
  getSysteDate,
  getUserRoleId,
  getTrailPeriod,
  getUserInfo,
  getMenuList,
  getLoadingDataFirstTime,
  getUserList,
} from "redux/selectors";
import ProcessingModal from "molecules/ProcessingModal";
import { CALL_API } from "common/API";
import { useURLToken, extractTokenFromUrl } from "hooks/useURLToken";
import { getServerDateToMySql } from "utils/Date";
import PrivacyAndPolicy from "pages/PrivacyAndPolicy";
import { jwtDecode } from "jwt-decode";
import AppSideBar from "molecules/AppSideBar";
import FormResponse from "pages/FormResponse";
import { find } from "lodash";
import Login from "pages/Login";
import UserManual from "pages/UserManual";
import PublicDemo from "pages/PublicDemo";
import COLORS from "common/Colors";
import { getUserLocalTime } from "utils/Date";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

var createHost = require("cross-domain-storage/host");
export const LayoutContext = React.createContext({
  showLayout: true,
  setShowLayout: () => { },
});
const StyledAppDiv = styled.div`
  height: 100%;
`;
const PlanWrap = styled(Row)`
  background-color: #d32f2f;
  height: 30px;
  padding: 5px;
  box-shadow: 5px 5px 10px #00000029;
  cursor: pointer;
  .title {
    font-weight: bold;
    color: #fff;
  }
  .subtitle {
    font-weight: bold;
    color: #ffff00;
  }
  .black-title {
    color: #000000;
  }
`;

const StyledSkeletonWrapper = styled.div`
  height: 100vh;
  display: flex;
  background-color: #f0f2f5;
  
  .app-sidebar-skeleton {
    width: 70px;
    background-color: #ffffff;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
    
    .sidebar-logo {
      width: 50px;
      height: 50px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  
  .main-sidebar-skeleton {
    width: 250px;
    background-color: #ffffff;
    padding: 20px;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
    
    .ant-skeleton-element {
      margin-bottom: 16px;
    }
  }
  
  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .header-skeleton {
    height: 64px;
    background-color: #ffffff;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    
    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      
      .header-logo {
        height: 40px;
        img {
          height: 100%;
          object-fit: contain;
        }
      }
    }
    
    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }
  
  .main-content-skeleton {
    flex: 1;
    background-color: #f0f2f5;
    margin: 24px;
    padding: 24px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    
    .spinner-overlay {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      .sync-icon {
        font-size: 100px;
        color: #999999;
        animation: rotate 1s linear infinite;
      }
      
      @keyframes rotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    }
  }
`;

const App = ({
  activePage,
  isUserLoggedIn,
  setUserLoggedIn,
  saveSystemDate,
  setBreakTypes,
  saveDepartmentList,
  saveAllDepartmentList,
  saveLeaveCategoryList,
  saveLocationList,
  savePunchActions,
  saveUsernName,
  toggleLoadingDataFirstTime,
  saveDepartmentId,
  saveRoleList,
  updateCheckInLocationId,
  updateIsOnBreak,
  updateCheckedIn,
  updateUserList,
  saveStatusList,
  savePunchId,
  saveBreakId,
  updateProcessingModal,
  saveShiftTimeMaster,
  saveUserProfile,
  removeStoreData,
  saveProfilePic,
  saveUserRole,
  saveMenuList,
  saveBandList,
  saveClientid,
  saveTrailPeriod,
  saveCurrentPlan,
  userRoleId,
  TrailPeriod,
  saveUserMenuList,
  updateCheckInDepartmentId,
  menuList,
  saveActiveMenuList,
  saveSupervisorList,
  saveLevelList,
  isLoadingDataFirstTime,
  loadingRoute,
  saveStatusCodes,
  saveCRMManagingOfficeList,
  userInfo,
  setLoadNewData,
}) => {
  createHost([
    {
      origin: "http://localhost:3000",
      allowedMethods: ["get", "set", "remove"],
    },
    {
      origin: "http://localhost:3001",
      allowedMethods: ["get", "set", "remove"],
    },
    {
      origin: "https://www.tractask.waila.co",
      allowedMethods: ["get", "set", "remove"],
    },
    {
      origin: "https://www.crm.waila.co",
      allowedMethods: ["get", "set", "remove"],
    },
    {
      origin: "http://localhost:3001/",
      allowedMethods: ["get", "set", "remove"],
    },
  ]);

  const [pageTitle, setPageTitle] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [intervalID, setIntervalID] = useState(0);
  const [open, setOpen] = useState(false);
  const [showplan, setshowplan] = useState(false);
  const [sessionTimeout, setSessionTimeout] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuLists, setMenuLists] = useState([]);
  const [isRecruitment, setIsRecruitment] = useState(false);
  const [permissionChecked, setPermissionChecked] = useState(false);
  // Captured once, synchronously, on the very first render — before
  // useURLToken's effect has a chance to strip `?token=...` from the URL.
  // Used to keep the loader on screen for the whole login redirect flow
  // (token extraction -> validation -> storage -> master data fetch)
  // instead of only during the later "route permission check" phase.
  const [hasUrlTokenAtLoad] = useState(() => !!extractTokenFromUrl());
  const [showLayout, setShowLayout] = useState(true);
  const [showExpiryWarning, setShowExpiryWarning] = useState(false);
  const [expiryWarningShown, setExpiryWarningShown] = useState(false);
  const [tokenExpiry, setTokenExpiry] = useState(false);


  const dispatch = useDispatch();

  const userDataList = useSelector((state) => getUserList(state)) || [];

  // const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const location = useLocation();
  const currentPath = location.pathname;



  const userMenuList =
    menuList[userRoleId] || Object.values(menuList)[0] || [];

  const hasAccessToKey = (key) => {
    return userMenuList.some((menu) => {
      if (menu.key === key && menu.access) return true;

      if (menu.subMenu?.length) {
        return menu.subMenu.some(
          (sub) => sub.key === key && sub.access
        );
      }

      return false;
    });
  };

  const matchPath = (routePath, actualPath) => {
    const routeParts = routePath.split("/").filter(Boolean);
    const actualParts = actualPath.split("/").filter(Boolean);

    if (routeParts.length !== actualParts.length) return false;

    return routeParts.every(
      (part, index) =>
        part.startsWith(":") || part === actualParts[index]
    );
  };

  const getKeysForRoute = (currentPath) => {
    // 1️⃣ Exact match
    if (routeToKeyMap[currentPath]) {
      const keys = routeToKeyMap[currentPath];
      return Array.isArray(keys) ? keys : [keys];
    }

    // 2️⃣ Dynamic route match
    for (const [routePath, keys] of Object.entries(routeToKeyMap)) {
      if (matchPath(routePath, currentPath)) {
        return Array.isArray(keys) ? keys : [keys];
      }
    }

    return [];
  };


  const checkRouteAccess = (routePath) => {
    const keys = getKeysForRoute(routePath);
    if (!keys.length) return false;
    return keys.some(hasAccessToKey);
  };

  useEffect(() => {
    if (!isUserLoggedIn) return;
    if (!userMenuList.length) return; // ⛔ WAIT HERE

    // public routes
    if (
      currentPath.startsWith("/privacy-policy") ||
      currentPath.startsWith("/form") ||
      currentPath === "/usermanual" ||
      currentPath.startsWith("/session-tracking")
    ) {
      setShowLayout(false);
      setPermissionChecked(true);
      return;
    }

    const hasAccess = checkRouteAccess(currentPath);
    setShowLayout(hasAccess);
    setPermissionChecked(true);
  }, [currentPath, userMenuList, isUserLoggedIn]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const toggleDrawer = () => {
    setCollapsed(!collapsed);
  };

  const isLoggedIn = () => {
    setUserLoggedIn(!isUserLoggedIn);
    toggleLoadingDataFirstTime(true);
    fetchMasterUserData(true);
    // setTimeout(() => {
    //   toggleLoadingDataFirstTime(false);
    // }, 500);
    fetchMasterData(true);
    getPreview();
  };

  const isLoggedOut = () => {
    // setUserLoggedIn(true);
    toggleLoadingDataFirstTime(true);
    setUserLoggedIn(false);
    sessionStorage.removeItem("tokenTimestamp");
    posthog.reset();
  };

  const logOut = () => {
    window.localStorage.removeItem("token");
    isLoggedOut();
    setSessionTimeout(false);
    window.location.href = "https://demo.app.bdo.insyts.co/";
  };

  const updatePageTitle = (title) => {
    setPageTitle(title);
  };

  // Handle token passed via URL query string (?token=...) when the user
  // is redirected here from the main insyts.ai portal after logging in there.
  const { status: urlStatus, error: urlError } = useURLToken();

  // True for the entire cross-domain login window: from the first render
  // (URL still has the token, useURLToken hasn't run yet) through token
  // validation/storage and until isUserLoggedIn actually flips true.
  // Once urlStatus is "error" we stop showing the loader so the redirect
  // back to the login page (below) isn't hidden behind it indefinitely.
  const isAuthenticatingFromUrl =
    hasUrlTokenAtLoad && !isUserLoggedIn && urlStatus !== "error";

  useEffect(() => {
    if (urlStatus === "success" && !isUserLoggedIn) {
      isLoggedIn();
    }
    if (urlStatus === "error") {
      console.error("login failed:", urlError);
      // No valid session to fall back on — send the user back to the
      // main portal to log in again.
      if (!window.localStorage.getItem("token")) {
        window.location.href = "https://demo.app.bdo.insyts.co/login";
      }
    }
  }, [urlStatus]);

  let defaultKey = "";

  useEffect(() => {
    if (isUserLoggedIn) {
      const intId = setInterval(() => {
        saveSystemDate(startTimeCounter());
      }, 1000);
      setIntervalID(intId);
      setUserLoggedIn(true);
      fetchMasterUserData(true);
      fetchMasterData(true);
    } else {
      clearInterval(intervalID);
    }
  }, []);

  useLayoutEffect(() => {
    clearInterval(intervalID);
    updateProcessingModal(false);
    if (window.innerWidth < 567) {
      toggleDrawer();
    }
  }, []);

  const redirectToNewDomain = () => {
    window.location.href = "https://www.tymeplushr.com/";
  };

  // localtoken is used For local development

  // const localtoken =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IldBOE1JWVQiLCJ1c2VySWQiOiJzaXZhc21rNTNAZ21haWwuY29tIiwidXNlck5hbWUiOiJTaXZhIiwiaWF0IjoxNzExNTEwMDA4LCJleHAiOjE3MTE1MjgwMDh9.VAurlcnviSeoJ-MvUULzFOsDzCUKF156UvD_V9OqULU";

  // useEffect(() => {
  //   window.localStorage.setItem("token", localtoken);
  //   sessionStorage.setItem('tokenTimestamp', new Date().getTime().toString());
  //   getPreview()
  //   const clientid = jwtDecode(window.localStorage.getItem("token"))?.clientId;
  //   isLoggedIn(clientid);
  //   setUserLoggedIn(true)
  // }, []);

  const urlParts = window.location.pathname.split("/");
  const clientIdFromUrl = urlParts[2];
  const idFromUrl = urlParts[3];
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (urlParts[1] === "form" && clientIdFromUrl && idFromUrl) {
          console.log("Form response");
          setIsRecruitment(true);
          setUserLoggedIn(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []); // Empty dependency array ensures the effect runs only once on mount

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = window?.localStorage?.getItem("token");
      const decodedToken = token ? jwtDecode(token) : null;
      if (!decodedToken || !decodedToken.exp) return;

      const currentTime = new Date().getTime();
      const expirationTime = decodedToken.exp * 1000;

      const fiveMinutes = 5 * 60 * 1000;

      if (
        expirationTime - currentTime <= fiveMinutes &&
        expirationTime - currentTime > 0 &&
        !expiryWarningShown
      ) {
        setShowExpiryWarning(true);
        setExpiryWarningShown(true);
      }

      if (currentTime > expirationTime) {
        setSessionTimeout(true);
        setTokenExpiry(true);
      }
    };

    checkTokenExpiration();
    const intervalId = setInterval(checkTokenExpiration, 60000);

    return () => clearInterval(intervalId);
  }, [expiryWarningShown]);

  useEffect(() => {
    if (userInfo?.managingoffice?.length > 0) {
      const userCountry = userInfo.managingoffice[0];
      const updateTime = () => {
        const { time, amPm } = getUserLocalTime(userCountry);
        dispatch(setUserLocalTimeZone(time));
        dispatch(setUserAmPm(amPm));
      };
      updateTime();
      const intervalId = setInterval(updateTime, 60000);
      return () => clearInterval(intervalId);
    }
  }, [userInfo?.managingoffice, dispatch]);

  // const startTimeCounter = () => {
  //   // Get the user's current time zone
  //   const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   // Create a new Date object with the user's time zone
  //   const d = new Date();
  //   const ist = new Date(
  //     d.toLocaleString("en-US", { timeZone: userTimeZone })
  //   );

  //   return getServerDateToMySql(ist);
  // };

  const startTimeCounter = () => {
    // Create a new Date object with the Kenya time zone
    const d = new Date();
    const kenyaTime = new Date(
      d.toLocaleString("en-US", { timeZone: "Africa/Nairobi" })
    );

    return getServerDateToMySql(kenyaTime);
  };

  const fetchMasterUserData = async (fetch_master_userdata) => {
    const token = window.localStorage.getItem("token");
    if (!token) {
      setUserLoggedIn(false);
      return;
    }
    const clientId = jwtDecode(token)?.clientId;
    const { code, role_id, menuList, clientid, higherOfficials, chargeOutData, countryList } = await CALL_API(
      `master-data/userdetails?clientid=${clientId}`,
      "GET",
      {
        fetch_master_userdata,
      }
    );

    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_userdata) {
        const homeMenuList = menuList[role_id[0]]?.filter(
          (menu) => menu.subMenu.length === 0 && menu.key !== "managementview"
        );

        saveActiveMenuList({
          [userRoleId]: homeMenuList,
        });

        const modifiedMenuList = menuList[role_id[0]].map((menu) => {
          if (menu.subMenu.length > 0) {
            return { ...menu, active: false };
          }
          return menu;
        });

        saveMenuList({ [role_id[0]]: modifiedMenuList });

        setMenuLists({
          [role_id[0]]: modifiedMenuList,
        });
      }
      dispatch(setHigherOfficialsList(higherOfficials || []));
      dispatch(setChargeoutRatesList(chargeOutData || []));
      dispatch(setCountryList(countryList || []));
      saveUserRole(role_id[0]);
      saveClientid(clientid);
      toggleLoadingDataFirstTime(false);

      // if (punch_action_id) {
      //   window.localStorage.setItem("login_reminder", "true");
      // }
    } else {
      setUserLoggedIn(false);
      // setSessionTimeout(true);
    }
  };

  const history = useHistory();

  const fetchMasterData = async (fetch_master_data) => {
    if (Array.isArray(userDataList) && userDataList?.length === 0) {
      loadingRoute(true);
    }
    const token = window.localStorage.getItem("token");
    if (!token) {
      setUserLoggedIn(false);
      return;
    }

    const clientId = jwtDecode(token)?.clientId;
    const {
      code,
      name,
      userid,
      baselocationid,
      role_id,
      breakList,
      roleList,
      departmentList,
      leaveCategories,
      locations,
      punchActions,
      location_id,
      punch_action_id,
      userList,
      statusList,
      shiftTimeMaster,
      break_id = "",
      department_id,
      location_name,
      joiningdate,
      username,
      email_id,
      job_title,
      department,
      payroll,
      staff_department_id,
      menuList,
      bandList,
      clientid,
      trailperiodendon,
      currentPlan,
      userMenuList,
      threadid,
      supervisorList,
      levelList,
      statusCodes,
      managingOfficeList,
      managingoffice,
    } = await CALL_API(`master-data/${clientId}`, "post", {
      fetch_master_data,
    });

    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        const setRoleList = find(roleList, { roleId: role_id[0] });
        setBreakTypes(breakList);

        const homeMenuList = menuList[role_id[0]]?.filter(
          (menu) => menu.subMenu.length === 0 && menu.key !== "managementview"
        );

        saveActiveMenuList({
          [userRoleId]: homeMenuList,
        });

        const modifiedMenuList = menuList[role_id[0]].map((menu) => {
          if (menu.subMenu.length > 0) {
            return { ...menu, active: false };
          }
          return menu;
        });

        saveMenuList({ [role_id[0]]: modifiedMenuList });

        setMenuLists({
          [role_id[0]]: modifiedMenuList,
        });

        saveBandList(bandList);
        saveUserMenuList(userMenuList);
        saveDepartmentList(setRoleList?.department);
        saveAllDepartmentList(departmentList);
        saveDepartmentId(setRoleList?.department);
        saveLeaveCategoryList(leaveCategories);
        saveLocationList(locations);
        saveTrailPeriod(trailperiodendon);
        saveCurrentPlan(currentPlan);
        saveClientid(clientid);
        savePunchActions(punchActions);
        saveUsernName(name);
        saveRoleList(roleList);
        updateUserList(userList);
        saveStatusList(statusList);
        saveShiftTimeMaster(shiftTimeMaster);
        saveLevelList(levelList);
        saveUserProfile({
          location_name,
          joiningdate,
          username,
          email_id,
          job_title,
          department,
          payroll,
          userid,
          staff_department_id,
          threadid,
          role_id,
          baselocationid,
          managingoffice,
        });
        posthog.identify(userid, {
          email: email_id,
          name: name,
          clientId: clientid,
          roleId: role_id[0],
          managingOffice: managingoffice?.[0] || null,
          country: managingoffice?.[0] || null,
        });
      }

      updateCheckInLocationId(location_id?.toString());
      updateCheckInDepartmentId(department_id?.toString());
      updateIsOnBreak(break_id ? true : false);
      saveBreakId(break_id);
      savePunchId(punch_action_id);
      saveUserRole(role_id[0]);
      updateCheckedIn(punch_action_id ? true : false);
      saveSupervisorList(supervisorList);
      loadingRoute(false);
      saveStatusCodes(statusCodes);
      saveCRMManagingOfficeList(managingOfficeList);
      setLoadNewData([]);

      if (punch_action_id) {
        window.localStorage.setItem("login_reminder", "true");
      }
    } else {
      setUserLoggedIn(false);
      loadingRoute(false);
      // setSessionTimeout(true);
    }
  };

  const getPreview = async () => {
    const token = window.localStorage.getItem("token");

    const clientId = jwtDecode(token)?.clientId;

    const { code, url } = await CALL_API(
      `profile-upload/${clientId}`,
      "get",
      {}
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveProfilePic(url);
    }
  };

  // const currentPath = window.location.pathname;
  const isUserManual = currentPath === "/usermanual";
  const isPublicDemo = currentPath.startsWith("/session-tracking");

  // Login now happens on the main insyts.ai portal, which redirects back
  // here with a token (see useURLToken above). No local session to fall
  // back on means there's nothing to show here - send the user there
  // instead of rendering the old in-app login page.
  // useEffect(() => {
  //   if (
  //     !isUserLoggedIn &&
  //     !isAuthenticatingFromUrl &&
  //     !isRecruitment &&
  //     !isUserManual &&
  //     !isPublicDemo
  //   ) {
  //     window.location.href = "https://demo.app.bdo.insyts.co/login";
  //   }
  // }, [isUserLoggedIn, isAuthenticatingFromUrl, isRecruitment, isUserManual, isPublicDemo]);

  useEffect(() => {
    if (!isUserLoggedIn) return;
    let activityTimer;
    const resetTimer = () => {
      if (activityTimer) {
        clearTimeout(activityTimer);
      }
      activityTimer = setTimeout(() => {
        window.localStorage.removeItem("token");
        sessionStorage.removeItem("tokenTimestamp");
        setSessionTimeout(true);
        setTokenExpiry(true);
      }, 14400000);
    };
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    activityEvents.forEach(event => {
      window.addEventListener(event, resetTimer);
    });
    resetTimer();
    return () => {
      if (activityTimer) {
        clearTimeout(activityTimer);
      }
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [isUserLoggedIn]);

  if ((isUserLoggedIn && !permissionChecked) || isAuthenticatingFromUrl) {
    return (
      <StyledSkeletonWrapper>
        {/* App Sidebar Skeleton */}
        <div className="app-sidebar-skeleton">
          <div className="sidebar-logo">
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23e0e0e0'/%3E%3C/svg%3E" alt="Logo" />
          </div>
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
          <Skeleton.Avatar active size={40} shape="square" />
        </div>

        {/* Main Sidebar Skeleton */}
        <div className="main-sidebar-skeleton">
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
          <Skeleton.Button active size="large" block style={{ marginBottom: 16 }} />
        </div>

        {/* Content Area */}
        <div className="content-area">
          {/* Header Skeleton */}
          <div className="header-skeleton">
            <div className="header-left">
              <div className="header-logo">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 60'%3E%3Crect width='80' height='60' fill='%23e0e0e0'/%3E%3Crect x='100' width='100' height='60' fill='%23f0f0f0'/%3E%3C/svg%3E" alt="Header Logo" />
              </div>
            </div>
            <div className="header-right">
              <Skeleton.Button active size="default" style={{ width: 100 }} />
              <Skeleton.Avatar active size={40} shape="circle" />
            </div>
          </div>

          {/* Main Content Skeleton with SyncOutlined Spinner */}
          <div className="main-content-skeleton">
            <div className="spinner-overlay">
              <SyncOutlined className="sync-icon" />
            </div>
          </div>
        </div>
      </StyledSkeletonWrapper>
    );
  }

  // 🚫 Show 403 ONLY after permission is confirmed
  if (isUserLoggedIn && userMenuList.length > 0 && permissionChecked && !showLayout && !isPublicDemo) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have permission to access this page."
        extra={
          <Button type="primary" onClick={() => window.location.href = "/"}>
            Go to Home
          </Button>
        }
      />
    );
  }

  return (
    <StyledAppDiv>
      <Router>
        <Route path="/privacy-policy">
          <PrivacyAndPolicy />
        </Route>
        <Route path="/form/:clientId/:id">
          <FormResponse />
        </Route>
        <Route path="/usermanual">
          <UserManual />
        </Route>
        <Route path="/session-tracking">
          <PublicDemo />
        </Route>
      </Router>

      {isUserLoggedIn && !isUserManual && showLayout && (
        <>
          <LayoutContext.Provider value={{ showLayout, setShowLayout, }}>
            <Router>
              <RouteTracker />
              <Layout isapp={`${navigator.userAgent === "application"}`}>
                {!isLoadingDataFirstTime && (
                  <Layout.Sider width={70} style={{ background: COLORS.PRIMARY }}>
                    <AppSideBar open={drawerOpen} setOpen={setDrawerOpen} />
                  </Layout.Sider>
                )}

                <SideBar
                  open={open}
                  onClose={onClose}
                  setPageTitle={updatePageTitle}
                  defaultKey={defaultKey}
                  activePage={activePage}
                  collapsed={collapsed}
                  toggleCollapse={toggleDrawer}
                />

                <Layout>
                  <Header
                    showDrawer={showDrawer}
                    pageTitle={pageTitle}
                    setLoggedIn={isLoggedIn}
                    setPageTitle={updatePageTitle}
                    toggleCollapse={toggleDrawer}
                    collapsed={collapsed}
                    showplan={showplan}
                    setshowplan={setshowplan}
                    isLoggedOut={isLoggedOut}
                  />

                  <Container menuLists={menuLists} appBarWidth={"0"} />
                </Layout>
              </Layout>
            </Router>
          </LayoutContext.Provider>
          <Modal
            visible={showExpiryWarning}
            footer={null}
            closable={false}
            maskClosable={false}
          >
            <Result
              status="warning"
              title="Your session will expire in 5 minutes"
              subTitle="Please save your work. Otherwise, your unsaved data may be lost."
              extra={
                <Button
                  type="primary"
                  onClick={() => setShowExpiryWarning(false)}
                >
                  OK
                </Button>
              }
            />
          </Modal>

        </>
      )}

      {!isUserLoggedIn && !isRecruitment && !isUserManual && !isPublicDemo && (
        <Login setLoggedIn={isLoggedIn} />
      )}

      <ProcessingModal />

      <Modal
        visible={sessionTimeout}
        maskClosable={false}
        title={null}
        footer={null}
        closable={false}
      >
        <Result
          icon={<FieldTimeOutlined />}
          title="Your session has expired!"
          extra={
            <Button onClick={() => logOut()} type="primary">
              Login
            </Button>
          }
        />
      </Modal>
    </StyledAppDiv>
  );
};

const mapStateToProps = (state) => ({
  isUserLoggedIn: getIsUserLoggedIn(state),
  userName: getUserName(state),
  systeDate: getSysteDate(state),
  userRoleId: getUserRoleId(state),
  TrailPeriod: getTrailPeriod(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state),
  isLoadingDataFirstTime: getLoadingDataFirstTime(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setUserLoggedIn: setIsUserLoggedIn,
      saveSystemDate: setSystemDate,
      saveUsernName: setUsernName,
      setBreakTypes: setBreakTypesList,
      saveDepartmentList: setDepartmentList,
      saveSupervisorList: setSupervisorList,
      saveAllDepartmentList: setAllDepartmentList,
      saveLeaveCategoryList: setLeaveCategoryList,
      saveLocationList: setLocationList,
      savePunchActions: setPunchActions,
      saveUserRole: setUserRole,
      toggleLoadingDataFirstTime: setLoadingDataFirstTime,
      loadingRoute: setLoadingRoute,
      saveDepartmentId: setDepartmentId,
      saveRoleList: setRoleList,
      updateCheckedIn: setCheckedIn,
      updateCheckInLocationId: setCheckInLocationId,
      updateIsOnBreak: setIsOnBreak,
      updateUserList: setUserList,
      saveStatusList: setStatusList,
      savePunchId: setPunchId,
      saveBreakId: setBreakId,
      updateProcessingModal: toggleProcessingModal,
      saveShiftTimeMaster: setShiftTimeMaster,
      saveUserProfile: setUserProfile,
      removeStoreData: clearStore,
      saveProfilePic: setProfilePic,
      saveMenuList: setMenuList,
      saveBandList: setBandList,
      saveUserMenuList: setUserMenuList,
      saveActiveMenuList: setActiveMenuList,
      saveClientid: setClientid,
      saveCurrentPlan: setCurrentPlan,
      saveTrailPeriod: setTrailPeriod,
      updateCheckInDepartmentId: setCheckInDepartmentId,
      saveLevelList: setLevelList,
      saveStatusCodes: setStatusCodes,
      saveCRMManagingOfficeList: setCRMManagingOfficeList,
      setLoadNewData: setLoadNewDataList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
